<template>
  <div class="w_page">
      <div class='sponserCatalogListNavWrapper'>
          <div class="sponserCatalogList">
            <div class="sponserCatalogList_wrapper">
            <div class=' swiper-container'>
                <div class="swiper-wrapper">
                  <div class=' swiper-slide sponserCatalogItemInner' >
                    <div class="sponserCatalogItem"   @click='getAjax(0,"")' >
                      <img src="../../images/jx.png" class='sponserCatalogLogo' />
                      <p class="sponserCatalogName" :class="sponserCatalogid==0?'selectName':''">精选</p>
                    </div>
                    <div class='triangle' v-if='sponserCatalogid==0'></div>
                  </div>
                  <div class='swiper-slide sponserCatalogItemInner' v-for="(item,index) in sponserCatalogLists" :key='item.id' :id="'button'+item.id" >
                    <div class="sponserCatalogItem" @click='getAjax(item.id,"")' to="/item" >
                      <img :src="item.logo" class='sponserCatalogLogo' ></image>
                      <div class="sponserCatalogName" :class="sponserCatalogid==item.id?'selectName':''">{{item.name}}</div>
                      <div class='activityNum'>{{item.c}}</div>

                    </div>
                    <div class='triangle' v-if='sponserCatalogid==item.id'></div>
                  </div>
                </div>
              </div>
            </div>
            <div class=' ponserCatalogItemAllBtn'>
              <div class="sponserCatalogItem" @click = "showClassify">
                <div class='sponserCatalogItemAllInner'>
                  <div class='sponserCatalogItemAll'>全部</div>
                  <div class='sponserCatalogName'>全部分类</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--列表组件-->
        <welfareList :sponserCatalogid='sponserCatalogid' :selectType='selectType'></welfareList>
        <welfareClassify :popupVisible='popupVisible' :getAjax  = 'getAjax' :showClassify = 'showClassify' ></welfareClassify>
    </div>

</template>
<script type = "text/ecamscript-6">
import Vue from 'vue'
import SwiperVue from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import $ from "jquery"
//导入列表组建
import WelfareList from  '@/components/welfare/welfareList'
import WelfareClassify from  '@/components/welfare/welfareClassify'
  export default {
    name:"welfare",
    data(){
      return{
        sponserCatalogLists:[],
        tabIndex:0,
        url:'',
        sponserCatalogid:0,
        selectType:'',
        popupVisible:false,
        swiperContain:""

      }
    },
    created () {
      this.login()
    },
    mounted () {

    },
    methods:{
      /*axios调用nav*/
       login () {
         this.url = "api/getSponserCatalogList.php"
         //console.log(this.url)
         this.$ajax.autoService
             .login(this.url)
             .then((res) => {
               this.sponserCatalogLists = this.sponserCatalogLists.concat(res.data.map(function(item){
                 return item
               }))
               this.$nextTick(() => {
                 var that = this;
               this.swiperContain = new SwiperVue('.swiper-container', {
                 "autoplay": false,
                 "slidesPerView" : '4.8',
                 'direction': 'horizontal',
                  'loop': false,
                  'slideToClickedSlide': true,
                  'watchSlidesProgress' : true,
                  'watchSlidesVisibility' : true,
                  'activeIndex':1
               })
             })
              //console.log(this.sponserCatalogLists)
             }, (res) => {
                 console.log("error")
             })
        },
        /*获取*/
        getAjax (param,searchkeys) {
          this.sponserCatalogid=param;
          // if(this.sponserCatalogid ==18){
          //   this.initialSlide = 2
          // }
          // else if(this.sponserCatalogid ==18){
          // this.initialSlide = 3
          // }
          //console.log(this.swiperContain.slideToClickedSlide)
          //$("#button"+this.sponserCatalogid).addClass('swiper-slide-visible')
          //alert(mySwiper.activeIndex);
          this.selectType = '';
          this.popupVisible = false

        },

        showClassify () {
          this.popupVisible = !this.popupVisible
        }
    },
    components:{
      'welfareList':WelfareList,
      'welfareClassify':WelfareClassify
    }
  }
</script>
<style lang="stylus">
  .w_page
    background:#fff
    .sponserCatalogListNavWrapper
      width: 100%
      height: 205px
      .sponserCatalogList
        width: 750px
        height: 205px
        box-sizing: border-box
        position: fixed
        top: 0px
        left: 0px
        background: #f2f2f2
        z-index:10
        .sponserCatalogList_wrapper
          width:100%
          padding-right: 145px
          white-space:nowrap
          box-sizing:border-box
          .sponserCatalogItemInner
            width: 125px
            position: relative
            display: inline-block
            padding:  30px 0 50px
            overflow:hidden
            .sponserCatalogItem
              font-size: 20px
              padding: 0px
              line-height: none
              background: none
              overflow: visible
              .sponserCatalogLogo
                width: 100px
                height:100px
                display: block
                margin: 0 auto
              .sponserCatalogName
                font-size: 22px
                color: #333
                margin-top: 10px
                line-height: 24px
                text-align: center
                overflow:hidden
                text-overflow: ellipsis
                white-space:nowrap
                &.selectName
                  color:#f40
              .activityNum
                position: absolute
                top: 8px
                left: 90px
                width: 32px
                height: 32px
                border-radius: 50%
                background: #f00
                font-size: 18px
                line-height: 30px
                color: #fff
                padding-top: 2px
                box-sizing: border-box
                text-align:center
            .triangle
              width: 0px
              height: 0px
              border: 14px solid transparent
              border-bottom: 14px solid #fff
              position: absolute
              left: 50%
              bottom: 10px
              transform: translateX(-50%)
              z-index:9
        .ponserCatalogItemAllBtn
          position: absolute
          right: 15px
          top:0px
          padding: 30px 0 20px 15px
          background: #f2f2f2
          .sponserCatalogItem
            font-size: 20px
            padding: 0px
            line-height: none
            background: none
            overflow: visible
            .sponserCatalogItemAllInner
              border-left: 1px solid #ddd
              /*px*/
              padding-left: 13px
              text-align:center
              .sponserCatalogItemAll
                width: 100px
                height: 100px
                background: linear-gradient(to right,#ff972b,#ff6108)
                border-radius: 20px
                font-size: 36px
                color: #fff
                line-height: 100px
                text-align: center
                margin: 0 auto
              .sponserCatalogName
                font-size: 22px
                color: #333
                margin-top: 10px
                line-height: 24px
                text-align: center
                overflow:hidden
                text-overflow: ellipsis
                white-space:nowrap
</style>



// WEBPACK FOOTER //
// src/components/welfare/welfare.vue